import React, { createContext, useReducer } from "react";
import taxonomy from "../data/taxonomy.json";
import { resolveBrand } from "../utils/brandResolver";

// Resolve brand from hostname
const brand = resolveBrand(window.location.hostname + (window.location.port ? ':' + window.location.port : ''));

const initialState = {
  // Brand config (resolved from domain)
  brand: brand,
  // Legacy alias
  client: {
    ...brand,
    name: brand.name,
    shortName: brand.shortName,
    phone: brand.phone,
    phoneExisting: brand.phoneExisting || null,
    email: brand.email,
    logo: brand.logo,
    colors: brand.colors,
    schema: brand.schema,
    socialLinks: brand.socialLinks,
    defaultLocale: "en",
    supportedLocales: ["en", "es", "pt", "ko", "ja", "fr"],
  },
  taxonomy: taxonomy,

  // UI state
  isMobile: false,
  isMobileMenuOpen: false,

  // Locale
  locale: "en",

  // Page data cache
  pageCache: {},

  // Loading states
  isLoading: false,
  error: null,
};

function appReducer(state, action) {
  switch (action.type) {
    case "SET_IS_MOBILE":
      return { ...state, isMobile: action.payload };

    case "SET_MOBILE_MENU":
      return { ...state, isMobileMenuOpen: action.payload };

    case "TOGGLE_MOBILE_MENU":
      return { ...state, isMobileMenuOpen: !state.isMobileMenuOpen };

    case "SET_LOCALE":
      return { ...state, locale: action.payload };

    case "SET_BRAND":
      return { ...state, brand: action.payload, client: { ...state.client, ...action.payload } };

    case "SET_PAGE_DATA":
      return {
        ...state,
        pageCache: {
          ...state.pageCache,
          [action.payload.slug]: action.payload.data,
        },
      };

    case "SET_LOADING":
      return { ...state, isLoading: action.payload };

    case "SET_ERROR":
      return { ...state, error: action.payload };

    case "CLEAR_ERROR":
      return { ...state, error: null };

    default:
      return state;
  }
}

export const ApplicationContext = createContext();

export function ApplicationContextProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <ApplicationContext.Provider value={{ state, dispatch }}>
      {children}
    </ApplicationContext.Provider>
  );
}
